export default __webpack_public_path__ + "static/media/photo-collage.9ef71519.png";